import axiosInstance from '@/core/api'
import type { components, operations } from '@/schema'

type GetPlayLogsParams =
	operations['AnalyticsController_getPlayLogs']['parameters']['query']
type GetPlayLogsResponse = components['schemas']['AdminPlayLogsListResponse']
type GetGameProvidersParams =
	operations['GameController_getGameProviderListForAdmin']['parameters']['query']
type GetGameProvidersResponse =
	components['schemas']['GameAdminProviderListResponse']
type GetAllPlayersGameStatsParams =
	operations['AnalyticsController_getAllPlayersGameStats']['parameters']['query']
type GetAllPlayersGameStatsResponse =
	components['schemas']['AdminGetAllPlayersGameStatsResponse']

export class PlayLogService {
	static async getPlayLogs(
		params?: GetPlayLogsParams,
	): Promise<GetPlayLogsResponse> {
		const { data } = await axiosInstance.get<GetPlayLogsResponse>(
			'/admin/analytics/playlogs',
			{
				params,
			},
		)
		return data
	}

	static async getGameProviders(
		params: GetGameProvidersParams,
	): Promise<GetGameProvidersResponse> {
		const { data } = await axiosInstance.get<GetGameProvidersResponse>(
			'/admin/game/provider/list',
			{
				params,
			},
		)
		return data
	}

	static async getAllPlayersGameStats(
		params: GetAllPlayersGameStatsParams,
	): Promise<GetAllPlayersGameStatsResponse> {
		const { data } = await axiosInstance.get<GetAllPlayersGameStatsResponse>(
			'/admin/analytics/all-players-game-stats',
			{
				params,
			},
		)
		return data
	}
}
